import { IFormValues } from "../../../form-modal/form-modal.types";
import { FormModal } from "../../../form-modal/form-modal.component";

import { DuplicateCampaignBriefForm } from "../duplicate-campaign-brief-form/duplicate-campaign-brief-form.component";
import { DuplicateCampaignBriefFormValidationRules } from "../duplicate-campaign-brief-form/duplicate-campaign-brief-form.validate";

import { DuplicateCampaignBriefModalProps } from "./duplicate-campaign-brief-modal.props";

export const DuplicateCampaignBriefModal = (props: DuplicateCampaignBriefModalProps) => {
  const handleSubmit = (data: IFormValues) => {
    props.onSubmit({ ...data, id: props.id });
  };

  return (
    <FormModal
      defaultValues={{ name: "" }}
      Form={DuplicateCampaignBriefForm}
      formValidation={DuplicateCampaignBriefFormValidationRules}
      isOpen={props.isOpen}
      modalErrors={props.errors}
      modalTitle="Duplicate Campaign Brief"
      onClose={props.onClose}
      submit={handleSubmit}
    />
  );
};
